import * as React from "react";
import { useLink, useLocation } from "@grandvisionhq/frk-routing";
import { appendQueryParamToUrl } from "../../../../utils/utils/get-updated-url-with-query-params.js";
const useRedirectToExpressCheckout = () => {
  const { href: expressCheckoutHref } = useLink({
    route: "express-checkout",
    params: {
      type: "APPLE_PAY",
      cartId: ""
    }
  }) || {};
  const { replace } = useLocation();
  const redirectToExpressCheckout = React.useCallback(
    (param) => {
      if (expressCheckoutHref) {
        replace(appendQueryParamToUrl(expressCheckoutHref, param));
      } else {
        throw Error("Failed redirection to /order/confirm. Route not found");
      }
    },
    [expressCheckoutHref, replace]
  );
  return redirectToExpressCheckout;
};
export {
  useRedirectToExpressCheckout
};
//# sourceMappingURL=use-redirect-to-express-checkout.js.map
